import { deepFreeze } from '../../utils/misc_utils';

export const StorePromotionTypeEnum = deepFreeze({
    CHEAPER_PRODUCT_FOR_NEW_USERS: {
        value: 'CHEAPER_PRODUCT_FOR_NEW_USERS',
        label: 'Tańszy produkt dla nowych użytkowników'
    },
    GREEN_PROMOTION_FOR_NEW_USERS: {
        value: 'GREEN_PROMOTION_FOR_NEW_USERS',
        label: 'Zielona promocja dla nowych użytkowników'
    },
    GREEN_PROMOTION_ONE_FREE: {
        value: 'GREEN_PROMOTION_ONE_FREE',
        label: 'Zielona promocja 1 + 1 gratis'
    },
    QUANTITATIVE_PROMOTION_ONE_CHEAPER: {
        value: 'QUANTITATIVE_PROMOTION_ONE_CHEAPER',
        label: 'Promocja ilościowa - upust na 2 produkt'
    },
    UNKNOWN: {
        value: 'UNKNOWN',
        label: 'Błąd'
    }
});
